import { clsx } from 'clsx';

import { CSSProperties } from 'react';

import './icons.css';
import { IconNamesUnion } from '@monoimin/sb-types';

import { UniversalImage } from '../image/UniversalImage';
export interface IconsProps {
  icon: IconNamesUnion;
  className?: string;
  sizeClassName?: string;
  isInteractive?: boolean;
  as?: 'div' | 'span';
  [k: string]: any;
}

export const Icons = ({
  className,
  sizeClassName = 'w-5 h-5',
  icon,
  isInteractive,
  as = 'div',
  ...props
}: IconsProps) => {
  if (!isInteractive) {
    return (
      <UniversalImage
        {...props}
        pattern='dimensions'
        width={20}
        height={20}
        src={`/images/icons-lib/${icon}.svg`}
        alt={`${icon} icon`}
        className={clsx(
          'icons-lib-img aspect-square duration-200 block',
          sizeClassName,
          className
        )}
        style={{
          ...props.style,
          height: 'auto',
        }}
        dataTestId={props['data-testid']}
      />
    );
  }

  const style: CSSProperties = {
    mask: `url("/images/icons-lib/${icon}.svg")`,
    WebkitMask: `url("/images/icons-lib/${icon}.svg")`,
  };

  const Root = as;

  return (
    <Root
      {...props}
      className={clsx(
        'icon-mask aspect-square bg-black-500 duration-200 icons-lib block',
        sizeClassName,
        className
      )}
      data-atom-name='icons'
      style={style}
    />
  );
};
